require('bootstrap/dist/js/bootstrap.min');
require('./custom.js');
require('./newsletter');